import purchasePdfApi from "../../../api/pdf/purchasePdfApi";

/**
 * 📄 Servicio para previsualizar o descargar PDFs de compras.
 * GET /api/pdf/purchases/{id}
 *
 * Devuelve tanto el blob como el nombre real del archivo (si viene en el header).
 */
const PurchasePdfService = {
  view: async (
    purchaseId: number
  ): Promise<{ blob: Blob; fileName: string | null }> => {
    const response = await purchasePdfApi.fetchBlob(`/${purchaseId}`);

    return {
      blob: response.data,
      fileName: response.fileName || null, // ✅ soporta filename desde el header
    };
  },
};

export default PurchasePdfService;
